import { defineMessages } from 'react-intl';

export const systemStatus = defineMessages({
  title: {
    id: 'system_status',
    defaultMessage: 'System status'
  },
  untilMessage: {
    id: 'modules.SystemStatus.untilMessage',
    defaultMessage: 'Until'
  },
  updates: {
    id: 'modules.SystemStatus.updates',
    defaultMessage: 'Updates'
  },
  affectedStations: {
    id: 'modules.SystemStatus.affectedStations',
    defaultMessage: 'Affected stations'
  },
  today: {
    id: 'modules.SystemStatus.today',
    defaultMessage: 'Today'
  },
  allSystemAlerts: {
    id: 'modules.SystemStatus.allSystemAlerts',
    defaultMessage: 'All system alerts'
  },
  systemIsUp: {
    id: 'modules.SystemStatus.systemIsUp',
    defaultMessage: 'The system is OK'
  },
  allDay: {
    id: 'modules.SystemStatus.allDay',
    defaultMessage: 'All day'
  },
  concluded: {
    id: 'modules.SystemStatus.concluded',
    defaultMessage: 'Concluded'
  },
  oneStationAffected: {
    id: 'modules.SystemStatus.oneStationAffected',
    defaultMessage: '{stationName} affected'
  },
  manyStationsAffected: {
    id: 'modules.SystemStatus.manyStationsAffected',
    defaultMessage: '{stationCount} stations affected'
  }
});
